import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URLs } from '../../core/conf/urls';
@Injectable({
  providedIn: 'root'
})
export class NmspLookupService {

  constructor(private readonly httpClient: HttpClient) { }

  overviewOperations() {
    return this.httpClient.get(URLs.OVERVIEW_OPERATIONS_ENDPOINT) as Observable<any[]>;
  }
}